<template>
    <v-app-bar
        :color="trainingMode ? '#ff9e0d' : '#1565c0'"
        app
        dark
        fixed
        clipped-left
    >
        <v-icon @click.stop="eventBus.$emit('order-toggle-drawer')">far fa-bars</v-icon>

        <div v-if="curOrder" class="ml-3">{{ $tc('general.receipt', 1) }}: {{ curOrder.number }}</div>

        <v-spacer />

        <div
            v-if="locale === 'me' && appConfig && appConfig.general && appConfig.general.supportNumber"
            class="d-flex align-center mx-4"
        >
            <v-icon size="28" class="mr-4">fab fa-viber</v-icon>
            {{ $t('general.support_message') }}
            <a
                class="ml-1 white--text"
                href="#"
                @click.prevent.stop="openViberSupport"
            >
                {{ appConfig.general.supportNumber }}
            </a>
        </div>

        <!-- <v-tooltip bottom>
            <template v-slot:activator="{ on }">
                <v-btn
                    icon
                    color="white"
                    v-on="on"
                    @click="$tours['appTour'].start()"
                >
                    <v-icon>fal fa-question-circle</v-icon>
                </v-btn>
            </template>
            <span>{{ $t('tour.guide') }}</span>
        </v-tooltip> -->

        <connection-management-button />

        <div v-if="user" class="logged-user">{{ user.name }}</div>

        <v-menu bottom transition="slide-y-transition">
            <template v-slot:activator="{ on }">
                <v-btn v-on="on" icon>
                    <v-icon>far fa-ellipsis-v</v-icon>
                </v-btn>
            </template>

            <v-list v-if="user" class="user-menu">
                <v-list-item :key="1" class="label">
                    <v-list-item-avatar>
                        <v-avatar class="primary" size="40">
                            <v-icon dark>fal fa-user</v-icon>
                        </v-avatar>
                    </v-list-item-avatar>

                    <v-list-item-content>
                        <v-list-item-title>{{ user.name }}</v-list-item-title>
                        <v-list-item-subtitle>{{ translateUserRole(user.role) }}</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>

                <v-divider />

                <v-list-item
                    v-if="locale === 'sr' && !einvoiceOnly"
                    :key="2"
                    :class="{ 'primary--text': trainingMode }"
                    @click="toggleTrainingMode"
                >
                    <v-list-item-action class="minw25 ml-1">
                        <v-icon>fal fa-chalkboard-teacher</v-icon>
                    </v-list-item-action>
                    <v-list-item-title>{{ trainingMode ? $t('general.training_stop') : $t('general.training_start') }}</v-list-item-title>
                </v-list-item>

                <v-list-item :key="3" @click="clockOut">
                    <v-list-item-action class="minw25 ml-1">
                        <v-icon>fal fa-user-clock</v-icon>
                    </v-list-item-action>
                    <v-list-item-title>{{ $t('general.clock_out') }}</v-list-item-title>
                </v-list-item>

                <v-list-item :key="4" @click="logout">
                    <v-list-item-action class="minw25 ml-1">
                        <v-icon>fal fa-sign-out</v-icon>
                    </v-list-item-action>
                    <v-list-item-title>{{ $t('general.log_out') }}</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>
    </v-app-bar>
</template>

<script>
import UserService from '@/services/UserService';
import EinvoiceService from '@/services/EinvoiceService';
import ConnectionManagementButton from '@/components/ConnectionManagementButton.vue';
import { mapGetters } from 'vuex';
import * as mutationTypes from '@/store/mutationTypes';

export default {
    name: 'OrderAppBar',

    components: {
        ConnectionManagementButton
    },

    data: () => ({
    }),

    computed: {
        ...mapGetters(['curOrder', 'trainingMode']),

        einvoiceOnly() {
            return EinvoiceService.einvoiceOnly();
        }
    },

    methods: {
        translateUserRole(role) {
            // if default role and name translation exists use it
            const transKey = `user_roles.default.${role.name}`
            if(this.$t(transKey) !== transKey && role.id <= 4) {
                return this.$t(transKey)
            }

            return role.name
        },

        toggleTrainingMode() {
            this.$store.commit(mutationTypes.SET_TRAINING_MODE, { trainingMode: !this.trainingMode });
        },

        clockOut() {
            UserService.clockOut();
            this.$router.push({ name: 'userLogin' }).catch(err => {});
        },

        logout() {
            UserService.logout();
            this.$router.push({ name: 'userLogin' }).catch(err => {});
        },

        openViberSupport() {
            window.open(`viber://chat?number=${this.appConfig.general.supportNumber}`);
        }
    }
};
</script>

<style lang="scss" scoped>
.logged-user {
    font-size: 15px;
    white-space: nowrap;

    @media screen and (max-width: 600px) {
        display: none;
    }
}

.user-menu {
    padding: 0;
    font-size: 16px;

    .label {
        background: #f0f0f0;
    }
}

.tabs {
    .first-tab {
        margin-left: 15px !important;
    }

    ::v-deep .v-slide-group__prev {
        display: none !important;
    }
}
</style>
